'use strict'

/**
 * Project janux-vuejs-seed
 * Created by hielo on 2018-04-24
 */

export const ExampleDirective = {
	bind (el) {
		el.style.color = 'red'
	}
}



// WEBPACK FOOTER //
// ./src/common/directives.js